import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PageListResponseDataItem } from 'src/api/models';
import { PageService } from 'src/api/services/page.service'
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-about',
  templateUrl: './uni-page.component.html',
  styleUrls: ['./uni-page.component.scss']
})
export class UniPageComponent implements OnInit {

  constructor(
    public pageService: PageService,
    private activateRoute: ActivatedRoute,
    private appService: AppService,
    public meta: Meta,
    public title: Title,
    private sanitizer: DomSanitizer,
  ) { }
  data: PageListResponseDataItem;
  sysname: string;
  private parametersObservable: any;
  ngOnDestroy(): void {
    if (this.parametersObservable != null) {
      this.parametersObservable.unsubscribe();
    }
  }
  setSEO() {
    const keywords = this.data.attributes.Seo ? this.data.attributes.Seo.keywords : null;
    const description = this.data.attributes.Seo ? this.data.attributes.Seo.metaDescription : null;
    this.meta = this.appService.setSEO(this.meta, keywords, description);
    if (this.appService.indexData && this.appService.indexData.attributes.HeaderTitle) {
      this.title.setTitle(this.data.attributes.Title + ' - ' + this.appService.indexData.attributes.HeaderTitle)
    }
  }
  ngOnInit(): void {

    this.parametersObservable = this.activateRoute.params.subscribe(result => {
      this.sysname = result['sysname'];
      const params = {
        filters: { "SysName": this.sysname },
        "populate": "Seo"
      }
      this.pageService.getPages(params).subscribe(data => {
        if (data.data.length > 0) {
          this.data = data.data[0];
          this.setSEO();
        }
      })
    });


  }

}
